import type { TenantStatus } from '@lib/enums/tenant-status.enum'
import { Badge } from '@/components/ui/badge'

/** An organization's status for staff: active, suspended (warning), or closed (neutral: it's over, not a problem). */
export function TenantStatusBadge({ status }: { status: TenantStatus }) {
  switch (status) {
    case 'active':
      return <Badge tone="success">Active</Badge>
    case 'suspended':
      return <Badge tone="warning">Suspended</Badge>
    case 'closed':
      return <Badge tone="neutral">Closed</Badge>
  }
}
